export default __webpack_public_path__ + "media/images/zinc-educational-services-vertical-6b393488.png";